module.exports = __webpack_public_path__ + "img/warabee_banner.e88254a2.png";